import React from 'react';
import { ExtractProps } from 'app/utils/types';
import BaseButton from 'app/components/common/BaseButton';

/**
 * This is nothing more than a `<button>` with aria attributes to make it look like a checkbox to
 * screen readers. You have to provide styles yourself to actually make it look like a checkbox.
 */
export interface IProps extends Omit<ExtractProps<typeof BaseButton>, 'onClick'> {
  checked: boolean;
  onToggle?: (checked: boolean) => void;
}

export default class CheckboxButton extends React.Component<IProps> {
  public render() {
    const {
      checked,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onToggle,
      ...rest
    } = this.props;

    return (
      <BaseButton
        {...rest}
        onClick={this.onClick}
        role="checkbox"
        aria-checked={checked ? 'true' : 'false'}
      />
    );
  }

  private onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Prevent onClick from getting triggered twice when the button is inside a <label>
    event.preventDefault();
    if (this.props.onToggle) {
      this.props.onToggle!(!this.props.checked);
    }
  };
}
